import { instance } from "../axios";

const ENDPOINTS = {
  visits: "/visit",
  sampleTypes: "/sampletypes",
  analysisContainers: "/analysiscontainers",
  temperatures: "/temperatures",
};

const getEndpoint = (entity) => {
  const endpoint = ENDPOINTS[entity];
  if (!endpoint) {
    throw new Error(`Unknown sample setup entity: ${entity}`);
  }

  return endpoint;
};

export const getSampleSetupItems = async (entity, studyId) => {
  const response = await instance.get(`${getEndpoint(entity)}/study/${studyId}`);
  return response.data;
};

export const getSampleSetupLists = async (studyId) => {
  const [visits, sampleTypes, temperatures] = await Promise.all([
    getSampleSetupItems("visits", studyId),
    getSampleSetupItems("sampleTypes", studyId),
    getSampleSetupItems("temperatures", studyId),
  ]);

  return {
    visits,
    sampleTypes,
    temperatures,
  };
};

export const createSampleSetupItem = async (entity, body) => {
  const response = await instance.post(getEndpoint(entity), body);
  return response.data;
};

export const updateSampleSetupItem = async (entity, id, body) => {
  const response = await instance.put(`${getEndpoint(entity)}/${id}`, body);
  return response.data;
};

export const deleteSampleSetupItem = async (entity, id) => {
  const response = await instance.delete(`${getEndpoint(entity)}/${id}`);
  return response.data;
};

const SAMPLE_SHIPMENT_DESTINATIONS_ENDPOINT = "/sampleshipmentdestinations";

export const getSampleShipmentDestinations = async (studyId) => {
  const response = await instance.get(
    `${SAMPLE_SHIPMENT_DESTINATIONS_ENDPOINT}/study/${studyId}`,
  );
  return response.data;
};

export const createSampleShipmentDestination = async (body) => {
  const response = await instance.post(
    SAMPLE_SHIPMENT_DESTINATIONS_ENDPOINT,
    body,
  );
  return response.data;
};

export const updateSampleShipmentDestination = async (id, body) => {
  const response = await instance.put(
    `${SAMPLE_SHIPMENT_DESTINATIONS_ENDPOINT}/${id}`,
    body,
  );
  return response.data;
};

export const deleteSampleShipmentDestination = async (id, studyId) => {
  const response = await instance.delete(
    `${SAMPLE_SHIPMENT_DESTINATIONS_ENDPOINT}/${id}`,
    { params: { studyId } },
  );
  return response.data;
};
